import classNames from 'classnames';
import { ButtonBase } from '../core/ButtonFactory';
import { ButtonIcon } from '../core/IconPosition';
import { styleFactory } from '../core/utils';
import {
  ActionButtonProps,
  ButtonStyle,
  IconTypes,
  LinkButtonProps,
} from '../types';
import styles from './iconButton.module.scss';

type IconButtonProps =
  | {
      icon: IconTypes;
      className?: string;
      style: {
        shape: 'circle' | 'square';
        ghost?: boolean;
      } & ButtonStyle;
    } & (LinkButtonProps | ActionButtonProps);

export const IconButton = ({
  icon,
  className,
  style: variant,
  ...props
}: IconButtonProps) => {
  const styleBuilder = styleFactory(styles, variant);

  styleBuilder.add([styles.iconButton]);
  styleBuilder.add([styles[variant.shape]]);

  if (variant.ghost) {
    styleBuilder.add([styles.ghost]);
  }

  const style = styleBuilder.get();

  return (
    <ButtonBase className={classNames(className, style)} {...props}>
      <ButtonIcon icon={icon} className={styles.icon} />
    </ButtonBase>
  );
};
